import { MediaVideo } from "client/common/types";
import { useCurrentLightbox } from "client/common/hooks/stackables";

import CloseButton from "../buttons/CloseButton";

import styles from "../../styles/VideoLightbox.module.less";

export type VideoLightboxProps = { video: MediaVideo };

const VideoLightbox = ({ video }: VideoLightboxProps) => {
  const { close } = useCurrentLightbox();
  return (
    <div>
      {video && (
        <iframe
          title={video.alt}
          className={styles.video}
          // Prevent video from playing when closed
          src={video.videoUrl}
          frameBorder="0"
        />
      )}
      <CloseButton className={styles.close} onClick={close} />
    </div>
  );
};

export default VideoLightbox;
